export default __webpack_public_path__ + "20e4cf21723cb447591e818fe4e30e5b.png";